import { RegistrationState } from "./RegistrationState";
import { RegStateValidate } from "./RegStateValidate";

/** Etat : Traitement d'un token de réinitialisation de mot de passe */
export class RegStateResetPassword extends RegistrationState{
    public async Next(): Promise<void> {
        /** Initialisation des messages affichés */
        this.context.Title = this.context.$t('ResetTitle').toString();
        this.context.FirstExplainLine = this.context.$t('ResetFirstExplainLine').toString();
        this.context.SecondExplainLine = "";
        this.context.SubmitText = this.context.$t('ResetSubmitText').toString();
        this.context.ShowResetIllustration = true;
        this.context.ShowLogin = false;


        /** Initialisation des messages affichés */
        this.context.ValidateTitle = this.context.$t('ValidateTitleResetPassword').toString();
        this.context.ValidateSuccessMessage = this.context.$t('ValidateSuccessResetPassword').toString();
        this.context.ValidateFailMessage = this.context.$t('ValidateFailResetPasswordTokenExpired').toString();

        /** Intialisation des champs de saisie */
        this.context.Login = this.analyseToken.Login ;
        this.context.Password = "";

        this.context.TransitionTo(new RegStateValidate(this))
    }
}